export const THEMES = [
  { key: "twilight", label: "Twilight", bg: "#0B0B12", accent: "#FFD60A", font: "'Clash Display', sans-serif", fontName: "Clash Display" },
  { key: "cyan", label: "Soft Cyan", bg: "#0A1014", accent: "#4FE0D0", font: "'Space Grotesk', sans-serif", fontName: "Space Grotesk" },
  { key: "ember", label: "Ember", bg: "#120D0B", accent: "#FF8C42", font: "'Zodiak', serif", fontName: "Zodiak" },
  { key: "violet", label: "Violet", bg: "#0C0A14", accent: "#B57BFF", font: "'Unbounded', sans-serif", fontName: "Unbounded" },
  { key: "mono", label: "Graphite", bg: "#0E0E11", accent: "#9FB3C8", font: "'Space Mono', monospace", fontName: "Space Mono" },
];
const KEY = "morpheus_theme";
export function getTheme() { try { return localStorage.getItem(KEY) || "twilight"; } catch (e) { return "twilight"; } }
export function setTheme(t) {
  try { localStorage.setItem(KEY, t); } catch (e) {}
  if (t && t !== "twilight") document.documentElement.setAttribute("data-theme", t);
  else document.documentElement.removeAttribute("data-theme");
}
export function applySavedTheme() {
  const t = getTheme();
  if (t && t !== "twilight") document.documentElement.setAttribute("data-theme", t);
}
